import React, { useState, useEffect, useCallback } from "react"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import AnchorLink from 'react-anchor-link-smooth-scroll'

import styles from "./index.module.css"

const navLinks = [
    { name: "Home", url: "#home", isAnchor: true, offset: "0" },
    { name: "About", url: "#about", isAnchor: true, offset: "80" },
    { name: "Experties", url: "#experties", isAnchor: true, offset: "0" },
    { name: "Technologies", url: "#technologies", isAnchor: true, offset: "80" },
    { name: "Contact", url: "#contact", isAnchor: true, offset: "0" },
    // { name: "Blog", url: "blogs", isAnchor: false }, // moved blog link to point to medium blogs
    { name: "Blog", url: "https://rishi-vedpathak.medium.com/", isAnchor: false },
];

const navBgFill = "#302040";
const navBgTransparent = "transparent";

export default () => {
    const [isFixedNavbar, setIsFixedNavbar] = useState(false);
    const [isMobile, setIsMobile] = useState(true);
    const [navbarBgColor, setNavbarBgColor] = useState("");
    const [isHomePage, setIsHomePage] = useState(false);

    const handleWindowScroll = useCallback(() => {
        const scrolledPos = document.documentElement.scrollTop || document.body.scrollTop;
        setIsFixedNavbar(scrolledPos > 200);
        setNavbarBgColor(scrolledPos > 200 ? navBgFill : isMobile ? navBgTransparent : navBgFill);
    }, [isMobile]);

    useEffect(() => {
        setIsHomePage(window.location.pathname === "/" ? true : false);
        setNavbarBgColor(isMobile ? navBgTransparent : navBgFill);
        const ismobileView = window.innerWidth <= 576;
        setIsMobile(ismobileView);
        window.addEventListener('scroll', handleWindowScroll);
        return function () {
            window.removeEventListener('scroll', handleWindowScroll);
        };
    }, [handleWindowScroll, isMobile]);

    const handleNavbarToggle = (expanded) => {
        setNavbarBgColor(expanded ? navBgFill : isFixedNavbar ? navBgFill : isMobile ? navBgTransparent : navBgFill);
    }

    return (
        (isMobile || isFixedNavbar || !isHomePage) ?
            <Navbar expand="md" className="navbar navbar-dark" collapseOnSelect style={{ backgroundColor: navbarBgColor }} fixed="top" onToggle={handleNavbarToggle}>
                <Navbar.Brand href="/">
                    Rishi Vedpathak
                </Navbar.Brand>
                {
                    isHomePage &&
                    <>
                        <Navbar.Toggle aria-controls="rsv-top-nav" />
                        <Navbar.Collapse className="justify-content-end" id="rsv-top-nav">
                            <Nav>
                                {
                                    navLinks.map((navLink, index) => (
                                        navLink.isAnchor
                                            ? <Nav.Link key={index} className={styles.navlinkItem} href={navLink.url} as={AnchorLink} offset={navLink.offset}>{navLink.name}</Nav.Link>
                                            : <Nav.Link key={index} className={styles.navlinkItem} href={navLink.url} target="_blank">{navLink.name}</Nav.Link>
                                    ))
                                }
                            </Nav>
                        </Navbar.Collapse>
                    </>
                }
            </Navbar>
            :
            <Nav className="position-absolute py-4 w-100 row" style={{ zIndex: "100" }}>
                {/* <Nav.Link className={styles.navlinkItem} href={"/"} sx={{ color: 'temp' }} style={{ alignSelf: "left" }}>Rishi Vedpathak</Nav.Link> */}
                <div className="justify-content-end col d-flex">
                    {
                        navLinks.map((navLink, index) => (
                            navLink.isAnchor
                                ? <Nav.Link key={index} className={styles.navlinkItem} href={navLink.url} as={AnchorLink} offset={navLink.offset}>{navLink.name}</Nav.Link>
                                : <Nav.Link key={index} className={styles.navlinkItem} href={navLink.url} target="_blank">{navLink.name}</Nav.Link>
                        ))
                    }
                </div>
                <div>
                </div>
            </Nav>
    )
}